import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

const pains = [
  {
    icon: 'ri-sun-line',
    text: '朝、目が覚めても体が重くて、起き上がるのがつらい',
  },
  {
    icon: 'ri-loader-4-line',
    text: '急にフワフワ、ぐるぐるする「めまい」が不安で外出できない',
  },
  {
    icon: 'ri-heart-pulse-line',
    text: '頭が重い、ズキズキする。でも薬には頼りたくない',
  },
  {
    icon: 'ri-moon-line',
    text: '夜、布団に入っても目が冴えてしまい、ぐっすり眠れない',
  },
  {
    icon: 'ri-hospital-line',
    text: '病院の検査では「異常なし」。でも、私の体はこんなに辛いのに…',
  },
];

const delayClasses = ['delay-2', 'delay-3', 'delay-4', 'delay-5', 'delay-6'];

export default function PainSection() {
  const { ref, isVisible } = useScrollAnimation();

  return (
    <section id="pain" className="bg-clinic-cream py-16 md:py-24">
      <div ref={ref} className={`w-full px-4 md:px-8 max-w-5xl mx-auto scroll-reveal ${isVisible ? 'visible' : ''}`}>
        <h2 className="font-serif text-xl md:text-3xl font-bold text-clinic-dark text-center mb-3 scroll-reveal-item delay-1">
          こんなお悩み、
          <br className="md:hidden" />
          一人で抱え込んでいませんか？
        </h2>
        <p className="text-clinic-gray text-sm md:text-base text-center mb-10 md:mb-14 scroll-reveal-item delay-1">
          小学生でもわかる「体のSOS」として表現します
        </p>

        <div className="space-y-4 md:space-y-5 mb-10 md:mb-14">
          {pains.map((pain, index) => (
            <div
              key={index}
              className={`bg-white rounded-xl p-4 md:p-6 flex items-start gap-4 shadow-sm scroll-reveal-item ${delayClasses[index]}`}
            >
              <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-full bg-clinic-terracotta-light shrink-0">
                <i className={`${pain.icon} text-clinic-terracotta text-lg md:text-xl`} />
              </div>
              <p className="text-clinic-dark text-sm md:text-base font-medium leading-relaxed pt-1 md:pt-2">
                {pain.text}
              </p>
            </div>
          ))}
        </div>

        <div className="bg-clinic-green-light rounded-xl p-6 md:p-8 text-center scroll-reveal-item delay-6">
          <p className="font-serif text-base md:text-xl font-bold text-clinic-green-dark leading-relaxed">
            「その原因、実は『安心ホルモン』が足りていないだけかもしれません」
          </p>
        </div>
      </div>
    </section>
  );
}